import { component$, Slot } from '@builder.io/qwik';

interface ConditionalWrapperProps {
  component: keyof HTMLElementTagNameMap | any;
  condition: boolean;
  props?: Record<string, any>;
}

export const ConditionalWrapper = component$(
  ({
    component: Component,
    condition,
    props = {},
  }: ConditionalWrapperProps) => {
    return condition ? (
      <Component {...props}>
        <Slot />
      </Component>
    ) : (
      <Slot />
    );
  }
);
